module.exports = __webpack_public_path__ + "static/media/Temitope_Akinsoto _BLOOMBERG APPLICATION.c7e69fe1.pdf";